import request from '@/utils/axios'

export function get(url,query) {
  return request({
    url: url,
    method: 'GET',
    params: query
  })
}
export function post(url,query) {
  return request({
    url: url,
    method: 'post',
    data: query
  })
}
export function put(url,query) {
  return request({
    url: url,
    method: 'put',
    data: query
  })
}
export function export_blob(url,query) {
  return request({
    url: url,
    method: 'get',
    responseType : 'blob',
    params: query
  })
}
export function del(url,query) {
  return request({
    url: url,
    method: 'delete',
    data: query
  })
}


// WEBPACK FOOTER //
// ./src/api/index.js